<script setup lang="ts">
import { getApiEnvironmentTone } from '@plf/utils/config'

const config = useRuntimeConfig()
const visible = computed(() => import.meta.dev || config.public.APP_ENV !== 'production')
const label = computed(() => {
  try {
    return new URL(config.public.BACKEND_URL).hostname === 'api.cue.business' ? 'PROD' : 'TEST'
  } catch {
    return 'TEST'
  }
})
const tone = computed(() => getApiEnvironmentTone(config.public.BACKEND_URL))
const DevEnvironmentTrigger = import.meta.dev
  ? defineAsyncComponent(() => import('@plf/components/dev/DevEnvironmentTrigger.vue'))
  : undefined
</script>

<template lang="pug">
.environment-indicator(v-if="visible" :class="{ 'environment-indicator--green': tone === 'green', 'environment-indicator--coral': tone === 'coral', 'environment-indicator--gray': tone === 'gray' }")
  DevOnly
    DevEnvironmentTrigger(:label="label")
    template(#fallback)
      span.badge {{ label }}
</template>

<style scoped>
.environment-indicator {
  pointer-events: auto;
}

.badge {
  --uno: flex-center-center h-20 p-0-12 br-0 br-b-12 typ-12-16-500;
  background: var(--environment-indicator-bg, var(--cue-bg-neutral-primary));
  color: var(--environment-indicator-content, var(--cue-content-neutral-secondary));
}

.environment-indicator--green {
  --environment-indicator-bg: var(--cue-contrast-contrast-5-soft);
  --environment-indicator-content: var(--cue-contrast-contrast-5-on-soft);
}

.environment-indicator--coral {
  --environment-indicator-bg: var(--cue-contrast-contrast-6-soft);
  --environment-indicator-content: var(--cue-contrast-contrast-6-on-soft);
}

.environment-indicator--gray {
  --environment-indicator-bg: var(--cue-contrast-contrast-7-soft);
  --environment-indicator-content: var(--cue-contrast-contrast-7-on-soft);
}
</style>
